// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import type {CopilotChatModel} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {useMemo, useState} from 'react'

export const useInitialCopilotContext = ({defaultModel}: {defaultModel: CopilotChatModel}) => {
  const [prompt, setPrompt] = useState('')
  const [selectedModel, setSelectedModel] = useState(defaultModel)

  const copilotContextValue = useMemo(() => {
    return {
      prompt,
      setPrompt,
      selectedModel,
      setSelectedModel,
    }
  }, [prompt, selectedModel])

  return {
    copilotContextValue,
  }
}
